export interface ISmartResult  {
    simulation_company:string			
    simulation_name:string
	simulation_iteration:number|null
	simulation_state:string
	error_msg:string
	processing_time:number|null
	surfacing_points:Array<Array<any>>
	mission_duration:string
	mission_end_date:string
	distance_traveled:number|null
	energy_available:number|null
	current_battery:number|null
	cycle_number:number|null
	current_cycle:number|null

	current_date:string
}

export function getDefaultSmartResult() {
	return {		
		simulation_company:"",
		simulation_name:"",
		simulation_iteration:null,
		simulation_state:"",
		error_msg:"",
		processing_time:null,
		surfacing_points:[],
		mission_duration:"",
		mission_end_date:"",
		distance_traveled:null,
		energy_available:null,
		current_battery:null,
		current_date:"",
		cycle_number:null,
		current_cycle:null
	} as ISmartResult
}